import { eventEmiter } from '../rxState';
import { API_SECTIONS } from '../../Constants';

import { api, getToken } from '../../utils/api';

export const saveSection = (state, { data, image }) => {
  const request = {
    action: 'create-section',
    data: JSON.stringify(data),
    token: getToken(),
    name: `section-` + Math.ceil(Math.random() * 100),
    image,
  };
  api(API_SECTIONS, 'POST',request)
    .then((res) => {
      eventEmiter.next({
        type: 'add-alert',
        payload: {
          type: 'success',
          text: 'Section saved',
        },
      });
    })
    .catch((error) => {
      eventEmiter.next({
        type: 'add-alert',
        payload: {
          type: 'error',
          text: 'API save section error',
          description: error.message,
        },
      });
    });
};
